module.exports = __webpack_public_path__ + "/9326a11224cf513ebd134760acb92e9a.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/assets/screenshot_onedrive.png
 ** module id = 1262
 ** module chunks = 0
 **/